var _jsxFileName = "/codebuild/output/src1346489397/src/bitbucket.org/newyuinc/adc-polaris-web/src/App.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal, Providers } from 'Components/utility';
const mapState = ({
  nav: {
    location,
    initErrorStatus,
    queryString,
    data
  }
}) => {
  return {
    initErrorStatus,
    queryString,
    location,
    data
  };
};
const connector = connect(mapState);
const App = ({
  initErrorStatus,
  location,
  data
}) => {
  const {
    Component,
    props
  } = useRouter(location, initErrorStatus, data);
  return /*#__PURE__*/React.createElement(Providers, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(GeneralModal, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }));
};
export default connector(App);